import { stardogAsyncThunkWrapper } from 'vet-bones/utils';

import { connectionSelector } from 'src/selectors/connection';
import { isConnectedSelector } from 'src/selectors/isConnected';
import { getStardogConnection } from 'src/utils/getStardogConnection';

export const createStardogAsyncThunk = stardogAsyncThunkWrapper({
  connectionSelector,
  getStardogConnection,
  onConnectionRefused: ({ api: { dispatch, getState }, connection, err }) => {
    const message = isConnectedSelector(getState())
      ? 'DISCONNECTED'
      : (err as Error).message;
    const connectionFailureAction = {
      type: 'connections/requestValidateConnection/rejected', // literal here to avoid circular dependency
      payload: { message },
      error: { message },
      meta: {
        aborted: false,
        arg: { connection },
        condition: false,
        rejectedWithValue: false,
        requestId: 'string',
        requestStatus: 'rejected',
      },
    };
    dispatch(connectionFailureAction);
  },
  onConnectionUnauthorized: ({ api: { dispatch } }) => {
    dispatch({
      payload: undefined,
      type: 'connections/disconnected', // action with literal here to avoid circular dependency
    });
  },
});
